import React from "react";
import "./css/ErrorMessage.css";
import { useDispatch } from "react-redux";

import { uiStateActions } from "../../store/ui-state";

import { ReactComponent as ServerDownSvg } from "../../assets/server-down.svg";

function ErrorMessage() {
  const dispatch = useDispatch();

  const retryHandler = () => {
    dispatch(uiStateActions.updateFirstRunState(true));
    // dispatch(uiStateActions.updateErrorState(false));
  };
  return (
    <div className="error-page">
      <ServerDownSvg className="error-graphic" />
      <p>Something went wrong</p>
      <button onClick={retryHandler}>Retry</button>
    </div>
  );
}

export default ErrorMessage;
